module.exports = __webpack_public_path__ + "static/media/palace.68a08540.png";